
import moment from 'moment';

export function getDateNow(withTime = false) {
    if (withTime)
        return new Date();
        //return new moment(new Date()).format('DD/MM/YYYY HH:mm:ss');
    else
        return new Date((new Date()).toDateString());
        //return new moment(new Date()).format('DD/MM/YYYY');
}

export function getDateToString(date, withTime = false) {
    if (date) {
        if (withTime)
            return new moment(date).format('DD/MM/YYYY HH:mm:ss');
        else
            return new moment(date).format('DD/MM/YYYY');
    }
    else {
        return '';
    }
}

export function getTimeToString(time) {
    if (time) {
        return new moment(time).format('HH:mm:ss');
    }
    else {
        return '';
    }
}

export function getObjectWithoutTypeName(object) {
    const { __typename, ...props } = object;
    return props;
}

export function getArrayObjectWithoutTypeName(array) {
    return array.map(item => {
        const { __typename, ...props } = item;
        return props;
    });
}